export default __webpack_public_path__ + "locales/uk-UA/Files.json?hash=24a63285aac1e08aab5f1d8853a3922f";